import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdSearchValueObject} from './FilterIdSearchValueObject.js'

export class FilterMaxTermsSearchValueObject extends ValueObject {
  #maxTerms

  constructor({maxTerms}) {
    super()
    this.#maxTerms = maxTerms
  }

  static create({maxTerms}) {
    return new FilterMaxTermsSearchValueObject({maxTerms: FilterIdSearchValueObject.create(maxTerms)})
  }

  static createWithDefaultValue({config, maxTerms}) {
    const {DEFAULT_FINANCING_TERMS_SEARCH} = config.get('searchFilters')

    return new FilterMaxTermsSearchValueObject({
      maxTerms: FilterIdSearchValueObject.create({id: maxTerms ?? DEFAULT_FINANCING_TERMS_SEARCH})
    })
  }

  static createQueryParams({config, maxTerms}) {
    const {DEFAULT_FINANCING_TERMS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterMaxTermsSearchValueObject({
      maxTerms: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.FINANCING_TERMS],
        value: maxTerms || DEFAULT_FINANCING_TERMS_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#maxTerms.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#maxTerms.queryParam})
    }
  }

  get value() {
    return this.#maxTerms.value
  }

  toJSON() {
    return {
      maxTerms: this.#maxTerms.toJSON()
    }
  }
}
